<script>
import bem from '@/utils/bem';
import { mapActions, mapState } from 'vuex';

const b = bem('new-frame-in-collection');
export default {
  data() {
    return {
      availableFrameCollections: [],
      selectedFrames: [],
      isSelectedAll: false,
    };
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    hideModal: {
      type: Function,
      required: true,
    },
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    ...mapActions({
      updateCollectionFrameOptionsAction: 'collections/updateCollectionFrameOptions',
    }),
    handleOk() {
      const value = {
        value: {
          productCollectionId: this.collection.id,
          products: this.selectedFrames.map((frame) => ({
            id: frame.id,
            options: frame.options.map((opt) => ({ id: opt.id })),
          })),
        },
      };
      this.updateCollectionFrameOptionsAction(value);
      this.hideModal();
    },
    addFrameToList(frame) {
      // this.availableFrames = this.availableFrames.filter((item) => item.id !== frame.id);
      this.selectedFrames = [...this.selectedFrames, frame];
    },
    deleteFrameFromList(frame) {
      this.selectedFrames = this.selectedFrames.filter((item) => item.id !== frame.id);
      // this.availableFrames = [...this.availableFrames, frame];
    },
  },
  computed: {
    ...mapState({
      frames: (state) => state.createTemplate.frames,
      collection: (state) => state.collections.collection,
    }),
  },
  mounted() {
    this.availableFrameCollections = this.frames.reduce((acc, frame) => {
      if (!frame.productCollectionId && !frame.isDeleted) {
        if (!this.collection.products.some((pr) => pr.id === frame.id)) {
          if (acc[frame.frameMaterial.id]) {
            return {
              ...acc,
              [frame.frameMaterial.id]: {
                name: frame.frameMaterial.name,
                frames: [...acc[frame.frameMaterial.id].frames, frame],
              },
            };
          }
          return {
            ...acc,
            [frame.frameMaterial.id]: {
              name: frame.frameMaterial.name,
              frames: [frame],
            },
          };
        }
        return acc;
      }
      return acc;
    }, {});
  },
};
</script>

<template>
  <a-modal
      :open="show"
      @cancel="hideModal"
      @ok="handleOk"
      title="Choose frames"
      ok-text="Add"
  >
    <div :class="b('')">
      <div>Available list: </div>
      <div :class="b('available-list')">
        <div
            :class="b('frame-collection')"
            v-for="collection in availableFrameCollections"
            :key="collection.name"
        >
          <div :class="b('frame-collection-title')">{{ collection.name }}</div>
          <a-button
              :class="b('frame')"
              v-for="frame in collection.frames"
              :key="frame.id"
              @click="addFrameToList(frame)"
          >
            {{ frame.displayName }}
          </a-button>
        </div>
      </div>
      <div>Selected list: </div>
      <div :class="b('selected-list')">
        <a-button
            :class="b('frame')"
            v-for="frame in selectedFrames"
            :key="frame.id"
            @click="deleteFrameFromList(frame)"
            type="primary"
        >
          {{ frame.displayName }}
        </a-button>
      </div>
    </div>
  </a-modal>
</template>

<style lang="scss" scoped>
@import "@/styles/variables";
@import "@/styles/media";
@import "@/styles/fonts";

.new-frame-in-collection {
  &__available-list {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
  }

  &__frame-collection-title {
    font-weight: bold;
  }

  &__frame {
    margin: 5px;
  }
}
.ant-modal {
  width: fit-content !important;
  max-width: 800px !important;
}
</style>
